import { render, staticRenderFns } from "./ContratoContainer.vue?vue&type=template&id=5c7f282e&scoped=true"
import script from "./ContratoContainer.vue?vue&type=script&lang=js"
export * from "./ContratoContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7f282e",
  null
  
)

export default component.exports